import styles from './nlm.module.scss';
import { Box, Container, Tab, Tabs } from '@frontend-workspace/react-shared-lib';
import { Col, Row } from 'reactstrap';
import { useState } from 'react';
import { GetCurrentCompany } from '../../customer-context/customer-context';
import PageTitle from '../../page-title/page-title';
import NlmGrid from '../nlm-grid/nlm-grid';
import NlmGridSkeleton from './nlm-grid-skeleton';
import OfflineFilesList from '../../offline-files-list/offline-files-list';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface NlmProps { }

export function Nlm(props: NlmProps) {
  const { t } = useTranslation();
  const currentCompany = GetCurrentCompany();
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const navigateToTabOne = () => setSelectedTab(0);
  const navigateToTabTwo = () => setSelectedTab(1);
  console.log(selectedTab);

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t("app.offlineLicenses")} subtitle={`(${t("standard.admin")})`} />
            <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '30px' }}>
              <Tabs
                value={selectedTab}
                variant="scrollable"
                scrollButtons="auto">
                <Tab label={t("nlm.newOfflineFile")} onClick={navigateToTabOne} />
                <Tab label={t("nlm.existingOfflineFiles")} onClick={navigateToTabTwo} />
              </Tabs>
            </Box>
            {selectedTab === 0 && <>
              {!currentCompany ? <>
                <PageTitle title={t("nlm.createOfflineNlm")} showNoCompanyMessage={!currentCompany} />
                <NlmGridSkeleton />
              </> : <NlmGrid />}
            </>
            }
            {selectedTab === 1 && <OfflineFilesList />}
          </Box>
        </Col>
      </Row>
    </Container >
  );
}

export default Nlm;